<template>
  <i
    :class="['fa-solid', showMenu ? 'fa-times' : 'fa-bars']"
    @click="showMenu = !showMenu"
    ref="menuToggle"
  ></i>

  <transition name="translate-y">
    <div v-if="showMenu" class="menu__container row">
      <div class="menu box__shadow" :style="{ 'margin-right': menuRight }">
        <Language @click="showMenu = false" />

        <div class="links column">
          <a
            :href="`https://app.arcticreply.com/auth/login?language=${$store.state.language}&campaign=${$store.state.campaign}`"
            target="_blank"
            rel="noopener noreferrer"
            class="row"
          >
            <div class="icon row center">
              <i class="fa-solid fa-right-to-bracket"></i>
            </div>
            <span>{{ t('Login') }}</span>
          </a>

          <a
            :href="`https://app.arcticreply.com/auth/register?language=${$store.state.language}&campaign=${$store.state.campaign}`"
            target="_blank"
            rel="noopener noreferrer"
            class="row"
          >
            <div class="icon row center">
              <i class="fa-solid fa-user-plus"></i>
            </div>
            <span>{{ t('Register') }}</span>
          </a>

          <router-link
            :to="`/${$store.state.language}#generator`"
            class="row"
            @click="showMenu = false"
          >
            <div class="icon row center">
              <i class="fa-solid fa-vial"></i>
            </div>
            <span>{{ t('Test now') }}</span>
          </router-link>

          <router-link
            :to="`/${$store.state.language}#pricing`"
            class="row"
            @click="showMenu = false"
          >
            <div class="icon row center">
              <i class="fa-solid fa-money-bill"></i>
            </div>
            <span>{{ t('Pricing') }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </transition>

  <div v-if="showMenu" @click="showMenu = false" class="menu__overlay"></div>
</template>

<script>
import { ref, onMounted } from 'vue'
import Language from './Language.vue'

export default {
  name: 'Dropdown',
  components: { Language },
  setup() {
    const showMenu = ref(false)
    const menuToggle = ref(null)
    const menuRight = ref('0px')

    onMounted(() => {
      if (menuToggle.value) {
        const rect = menuToggle.value.getBoundingClientRect()
        menuRight.value = `${window.innerWidth - rect.right}px`
      }

      if (window.innerWidth <= 599) {
        menuRight.value = 0
      }
    })

    return {
      showMenu,
      menuToggle,
      menuRight,
    }
  },
}
</script>

<style lang="scss" scoped>
i {
  cursor: pointer;
  font-size: 1.5rem;
  z-index: 55;
}

.menu__container {
  position: fixed;
  top: 60px;
  left: 0;
  width: 100%;
  z-index: 50;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 599px) {
    justify-content: center;
  }

  .menu {
    padding: 30px;
    border-radius: 15px;
    background-color: var(--background-2);
    width: calc(95% - 60px);
    max-width: 300px;

    @media (max-width: 599px) {
      margin: 0;
    }

    .links {
      margin-top: -10px;

      a {
        margin-bottom: 10px;
        align-items: center;
        font-size: 1.1rem;

        &:last-of-type {
          margin-bottom: 0;
        }

        .icon {
          width: 40px;
          margin-right: 5px;

          i {
            font-size: 1.25rem;
          }
        }

        span {
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
}

.menu__overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 45;
}
</style>
